import styled, { css } from 'styled-components';
import { colors } from '../../../theme/colors';
import {
  SelectorContainer as Container,
  SelectorLabelText as LabelText,
  HiddenInput,
} from '../../sharedSelectorStyles';

export { Container, LabelText };

export const HiddenRadio = styled(HiddenInput).attrs({ type: 'radio' })``;

const getPrimaryColor = (props) => {
  if (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) {
    return props.theme.colors.brand.primary;
  }
  return colors.primary;
};

export const StyledRadioWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background: #ffffff;
  border: 2px solid ${(props) => (props.checked ? colors.primary : colors.brandLightGray)};
  border-radius: 50%;
  transition: all 0.2s;

  ${HiddenRadio}:focus + & {
    box-shadow: 0 0 0 3px rgba(0, 169, 255, 0.25);
  }

  ${HiddenRadio}:hover + & {
    ${(props) =>
      !props.checked &&
      !props.disabled &&
      css`
        border-color: ${getPrimaryColor(props)};
      `}
  }
`;

export const InnerCircle = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${(props) => getPrimaryColor(props)};
  border-radius: 50%;
  transform: scale(${(props) => (props.checked ? 1 : 0)});
  transition: transform 0.2s ease-in-out;
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Radio/components/RadioStyles.js